import Main from './Main/Main';
import Minimal from './Minimal/Minimal';
import Empty from './Empty/Empty';

export default {
  Main,
  Minimal,
  Empty,
};
